<template>
    <div id="news">
    <!-- <newsHeader ></newsHeader> -->
    <headerBlack-view></headerBlack-view>
    <!-- <breadCrumb></breadCrumb> -->
    <!-- <keep-alive> -->
      <!-- v-if="$route.meta.keepAlive" :key="key" -->
        <router-view></router-view>
    <!-- </keep-alive> -->
    <scorllTop></scorllTop>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>